import { GamesRounded, ShowChartRounded, CheckRounded, CloseRounded } from '@material-ui/icons'
import './styles.css'

const icons = {
    game: <GamesRounded />,
    line_chart: <ShowChartRounded />,
    check: <CheckRounded />,
    close: <CloseRounded />
}

export default function RawWideWithIcon({ config }) {
    const Icon = (props) => icons[config.icon]

    return (
        <div className={`raw-wide-icon-with-text ${config.variant || 'light'}`} style={{ ...(config.style || {}), backgroundColor: config.color || 'var(--color-main)' }}>
            <Icon style={{ color: config.color ? `${config.color} !important` : 'var(--color-main) !important', boxShadow: config.color ? `0px 0px 20px -8px ${config.color} !important` : '0px 0px 20px -8px var(--color-main) !important' }} />
            <h4 className='raw-wide-text' style={{ color: config.color || 'var(--color-main)', textAlign: 'left !important' }} dangerouslySetInnerHTML={{ __html: config.text }}></h4>
        </div>
    )
}